module.exports = __webpack_public_path__ + "static/media/business_bundle.454474a3.png";